import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import 'amfe-flexible'
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
import './assets/css/reset.css'
import './vant'

Vue.config.productionTip = false
// register global utility filters
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// import Vconsole from 'vconsole'

// let vConsole = new Vconsole()

// export default vConsole